var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGatsby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_123_1841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#663399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64342 23.3571C4.39342 21.1071 3.21484 18.1071 3.21484 15.2142L14.8934 26.7857C11.8934 26.6785 8.89342 25.6071 6.64342 23.3571ZM17.572 26.4642L3.53627 12.4285C4.71484 7.17852 9.42913 3.21423 15.0006 3.21423C18.9648 3.21423 22.3934 5.1428 24.5363 8.03566L22.9291 9.42852C21.1077 6.96423 18.2148 5.35709 15.0006 5.35709C10.822 5.35709 7.28627 8.03566 5.89342 11.7857L18.2148 24.1071C21.322 23.0357 23.6791 20.3571 24.4291 17.1428H19.2863V14.9999H26.7863C26.7863 20.5714 22.822 25.2857 17.572 26.4642Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_123_1841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatsby);
export default __webpack_public_path__ + "static/media/gatsby.e7263b61444b2ddfb9b91332324df290.svg";
export { ForwardRef as ReactComponent };